import { CalendarAddAlt } from "@carbon/icons-react";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import moment from "moment";
import { useTranslation } from "react-i18next";

import { InboundDeliveryItemFragment } from "../../../../../../models/autogenerated-deliveryService-gql/graphql";
import { HierarchicalDeliveryItem } from "../../../../../../models/hierarchicalDeliveryItem";
import { formattedTimeSlotString } from "../../../../../../utils/helper";
import InfoButtonWithPopover from "../infoButtonWithPopover/InfoButtonWithPopover";
import "./DetailsItemsTreeItem.scss";

interface DetailsItemsTreeItemProps {
  item: HierarchicalDeliveryItem;
  parentIndex: string;
  expandedItems: string[];
}

const DetailsItemsTreeItem = (props: DetailsItemsTreeItemProps) => {
  const { t } = useTranslation();
  const { item, parentIndex, expandedItems } = props;

  const isExpanded = expandedItems.includes(parentIndex);

  const renderTreeItemLabel = (item: InboundDeliveryItemFragment) => {
    switch (item.__typename) {
      case "MaterialItem":
        const formattedDateString =
          item.timeSlotResolved?.start &&
          moment(new Date(item.timeSlotResolved.start))
            .locale(t("locale"))
            .format(t("dateFormat"));

        return (
          <div className="item-row">
            {item.timeSlotResolved && (
              <CalendarAddAlt size={24} className="mr-10" />
            )}
            <div>
              <div>{`${item.number} - ${item.materialResolved?.name} ${item.materialResolved?.description && `(${item.materialResolved.description})`} - ${item.requestedQuantity}/${item.openQuantity}/${item.executedQuantity} ${item.unitOfMeasurementResolved?.unitOfMeasurement}`}</div>
              {item.timeSlotResolved && (
                <div>{`${formattedDateString} ${formattedTimeSlotString(item.timeSlotResolved.start, item.timeSlotResolved.end)}`}</div>
              )}
            </div>
          </div>
        );
      case "HandlingUnitItem":
        return (
          <div>{`${item.number} - ${item.huTypeResolved?.name} ${item.huTypeResolved?.description && `(${item.huTypeResolved.description}) - ${item.stockTypeResolved?.longName}`}`}</div>
        );
      default:
        return <></>;
    }
  };

  return (
    <div className="tree-item-label">
      <TreeItem
        key={parentIndex}
        itemId={parentIndex}
        label={renderTreeItemLabel(item)}
      >
        {item.children.map((child, childIndex) => (
          <DetailsItemsTreeItem
            key={childIndex}
            item={child}
            parentIndex={`${parentIndex}-${childIndex.toString()}`}
            expandedItems={expandedItems}
          />
        ))}
      </TreeItem>
      {!isExpanded && (
        <InfoButtonWithPopover
          className="tree-item-label-element"
          detailsItem={item}
        />
      )}
    </div>
  );
};

export default DetailsItemsTreeItem;
